import React, { useRef, useEffect, useState } from 'react';
import { styled } from 'styled-components';

const VideoContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -100;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    pointer-events: none;
  }
`;

const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 30%, rgba(0, 255, 136, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(68, 255, 153, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 60% 20%, rgba(0, 204, 106, 0.06) 0%, transparent 50%),
    linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%);
  animation: backgroundPulse 8s ease-in-out infinite alternate;
  z-index: 1;

  @keyframes backgroundPulse {
    0% {
      transform: scale(1) rotate(0deg);
      opacity: 0.8;
    }
    100% {
      transform: scale(1.1) rotate(2deg);
      opacity: 1;
    }
  }
`;

const VideoFrame = styled.iframe<{ $isVisible: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120vw;
  height: 67.5vw;
  min-height: 120vh;
  min-width: 213.33vh;
  transform: translate(-50%, -50%) scale(1.2);
  pointer-events: none;
  border: none;
  z-index: 0;
  opacity: ${props => props.$isVisible ? 0.7 : 0};
  transition: opacity 2s ease-in-out;
`;

const VideoBackground: React.FC = () => {
  const [showIframe, setShowIframe] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // Show iframe after a delay to ensure proper loading
    const timer = setTimeout(() => {
      setShowIframe(true);
    }, 1000);

    // Handle iframe load error
    const handleIframeError = () => {
      setVideoError(true);
      console.log('Video failed to load, using fallback background');
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('error', handleIframeError);
    }

    return () => {
      clearTimeout(timer);
      if (iframe) {
        iframe.removeEventListener('error', handleIframeError);
      }
    };
  }, []);

  return (
    <VideoContainer>
      <AnimatedBackground />
      
      {!videoError && (
        <VideoFrame
          ref={iframeRef}
          $isVisible={showIframe}
          src="https://www.youtube.com/embed/LcF6ut-1M94?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playlist=LcF6ut-1M94&start=0&fs=0&disablekb=1&enablejsapi=1"
          title="Background Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={false}
        />
      )}
    </VideoContainer>
  );
};

export default VideoBackground;